import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { BookingDetailPage } from "@/features/bookings/pages/booking-detail-page/booking-detail-page";
import { bookingDetailSearchSchema } from "@/features/bookings/schemas/booking-detail-search.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/bookings/$bookingId"
)({
	head: () => pageTitle("Booking"),
	validateSearch: zodValidator(bookingDetailSearchSchema),
	component: BookingDetailPage,
});
